import {
  createComponentImplementation,
  type ReactComponentImplementation,
} from '@a2ui/react/v0_9';
import { Catalog, DynamicStringSchema } from '@a2ui/web_core/v0_9';
import { cn } from '@risksmart-app/atomic-ui';
import { z } from 'zod';

import { RSHighcharts } from '@/components/highcharts/RSHighcharts';

import {
  CHART_CATALOG_ID,
  CHART_COMPONENT_NAME,
  CHART_TYPES,
  MAX_LABEL,
  MAX_POINTS,
  MAX_SERIES,
} from './catalogConstants';
import { buildChartOptions } from './chartOptions';

const CHART_HEIGHT_PX = 260;

const ChartApi = {
  name: CHART_COMPONENT_NAME,
  schema: z.object({
    chartType: z.enum(CHART_TYPES),
    title: DynamicStringSchema.optional(),
    categories: z.array(z.string().max(MAX_LABEL)).max(MAX_POINTS).optional(),
    series: z
      .array(
        z.object({
          name: z.string().max(MAX_LABEL),
          data: z.array(z.number().nullable()).max(MAX_POINTS),
        })
      )
      .max(MAX_SERIES),
    isStacked: z.boolean().optional(),
  }),
};

const Chart = createComponentImplementation(ChartApi, ({ props }) => (
  <div className={cn('w-full')}>
    <RSHighcharts
      options={buildChartOptions({
        chartType: props.chartType,
        ...(props.title === undefined ? {} : { title: props.title }),
        ...(props.categories === undefined
          ? {}
          : { categories: props.categories }),
        ...(props.isStacked === undefined
          ? {}
          : { isStacked: props.isStacked }),
        series: props.series,
      })}
      containerProps={{ style: { height: CHART_HEIGHT_PX } }}
    />
  </div>
));

export const chartCatalog: Catalog<ReactComponentImplementation> = new Catalog(
  CHART_CATALOG_ID,
  [Chart]
);
